module.exports = __webpack_public_path__ + "assets/images/$20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/$20.png
// module id = 1247
// module chunks = 1